import { AppThunk } from "../../store/store";
import { LOGGED_IN_ACCOUNT, SET_ID_VERIFICATION_TOKEN, SET_SUBDOMAIN, TOGGLE_API_REQUEST_SUCCESS, TOGGLE_LOADING, TOGGLE_MODAL_LOADING } from "../../store/system/types";
import { Subdomain } from "shared/Enums";
import accountService from "accessors/accountService";
import CustomerAccount from "models/account/customer/customerAccount";

export const toggleLoading = (
    isLoading: boolean
): AppThunk => async (dispatch) => {
    dispatch({
        type: TOGGLE_LOADING,
        payload: { isLoading: isLoading }
    });
};

export const toggleModalLoading = (
    isModalLoading: boolean
): AppThunk => async (dispatch) => {
    dispatch({
        type: TOGGLE_MODAL_LOADING,
        payload: { isModalLoading: isModalLoading }
    });
};

export const toggleAPIRequestSuccess = (
    apiRequestSuccess: boolean
): AppThunk => async (dispatch) => {
    dispatch({
        type: TOGGLE_API_REQUEST_SUCCESS,
        payload: { apiRequestSuccess: apiRequestSuccess }
    });
};

export const getLoggedInAccountInfo = (): AppThunk => async (dispatch) => {
    accountService.GetLoggedInProfile()
        .then((account: CustomerAccount) => {
            dispatch({
                type: TOGGLE_LOADING,
                payload: { isLoading: false }
            });

            // We are returning a blank object if there was an error
            if (Object.keys(account).length > 0) {
                dispatch({
                    type: LOGGED_IN_ACCOUNT,
                    payload: {
                        customerAccount: account
                    },
                });
            }
        })
};

export const setPlaidTokenData = (
    token: string,
    tokenExpirationDate: Date
  ): AppThunk => async (dispatch) => {
  
    dispatch({
      type: TOGGLE_LOADING,
      payload: { isLoading: false }
    });
  
    dispatch({
      type: SET_ID_VERIFICATION_TOKEN,
      payload: {
        token: token,
        tokenExpirationDate: tokenExpirationDate
      }
    })
  };

  export const updateReduxCustomerAccountData = (
    customerAccount: CustomerAccount
  ): AppThunk => async (dispatch) => {
  
    dispatch({
      type: TOGGLE_LOADING,
      payload: { isLoading: false }
    });
  
    dispatch({
        type: LOGGED_IN_ACCOUNT,
        payload: {
            customerAccount: customerAccount
        },
    });
  };

export const setSubdomain = (
    subdomain: Subdomain
): AppThunk => async (dispatch) => {
    dispatch({
        type: SET_SUBDOMAIN,
        payload: {
            subdomain: subdomain
        },
    });
}

export const updateCustomerAccount = (
    customerAccount: CustomerAccount
): AppThunk => async (dispatch) => {
    accountService.UpdateCustomerAccount(customerAccount)
        .then((success: boolean) => {
            dispatch({
                type: TOGGLE_LOADING,
                payload: { isLoading: false }
            });

            // We are returning a blank object if there was an error
            if (success) {
                dispatch({
                    type: LOGGED_IN_ACCOUNT,
                    payload: {
                        customerAccount: customerAccount
                    },
                });

                dispatch({
                    type: TOGGLE_API_REQUEST_SUCCESS,
                    payload: {
                        apiRequestSuccess: true
                    },
                });
            }
        })
};